import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledFromLockerNearMe = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 8,
			fill: "#FEF6EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.5,
			y: 6,
			width: 15,
			height: 12,
			rx: .5,
			fill: "white",
			stroke: "#B47F23"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 11,
			r: 1.5,
			fill: "#B47F23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 11.875V13.75",
			stroke: "#B47F23",
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledFromLockerNearMe);
const Memo = memo(ForwardRef);
export default Memo;
